import { rgba } from 'polished';
import React from 'react';

import { theme } from '../../theme';
import { StyledWrapper } from './Spinner.styles';
import { ISpinnerProps } from './Spinner.types';

const Spinner = ({
  backgroundColor = rgba(theme.colors.tenant.main, 0.1),
  className,
  foregroundColor = theme.colors.tenant.main,
  size = 20,
  speed = 1,
  strokeSize = 3,
}: ISpinnerProps): JSX.Element => {
  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
      className={className}
      foregroundColor={foregroundColor}
      size={size}
      speed={speed}
      strokeSize={strokeSize}
    />
  );
};

export default Spinner;
